export default {
  c1: '佈置',
  c2: '換裝',
  c3: '人物',
  c4: '保存',
  c5: '所有分類',
  c6: '牆紙',
  c7: '地板',
  c8: '窗⼾',
  c9: '掛飾',
  c10: '運動器材',
  c11: '植物',
  c12: '電視',
  c13: '沙發',
  c14: '茶几',
  c15: '落地燈',
  c16: '鏡子',
  c17: '活動限定',
  c18: '保存成功',
  c19: '請重試',
  c20: '佈置未保存',
  c21: '當前佈置內容尚未保存，離開後不會保留，是否要保存當前已擁有內容？',
  c22: '直接離開',
  c23: '保存已有',
  c24: '活動專屬',
  c25: '簡介',
  c26: '獲取途徑',
  c27: '去獲取',
  c28: '返回首頁',
  c29: '保存成功',
  c30: '請重試',
  c31: '跳過',
  c32: ' 點擊換上您喜歡的服裝',
  c33: '點擊切換人物/換裝/佈置玩法',
  c34: '下一步',
  c35: '我知道了',
  c36: '點擊選擇您想要的分類',
  c37: '點擊換上您喜歡的樣式/物品',
  c38: "裝扮完成後記得點擊",
  c39: '「保存」',
  c40: "噢",
  c41:'點擊選擇您的基礎形象',
  c42:'套裝',
  c43:'形象',
  c44:'保存中，請稍候…',
  c45:'風景',
  c46:'聖誕擺設',
  c47:'聖誕掛飾',
  c48:'個性功能',
  c49:'您已在新版本更新個人裝扮，請升級體驗最新功能哦',
  c50:'個性裝扮',
  c51:'主題介面',
  c52:'頭像挂飾',
  c53:'空間佈置',
  c50_1:'虛擬形象，隨心換',
  c51_1:'個性主題，探索可能',
  c52_1:'個性挂飾，海量享',
  c53_1:'我的世界，我話事',
  c54:'提示',
  c55:'進入該功能，將會進入MyLink元宇宙，您確定繼續嗎？',
  c56:'取消',
  c57:'確認',
  c58:'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/smallIcon1.png'
}
